import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useOutsideClick from "hooks/click-outside";
import { ReactComponent as CalandarIcon } from "assets/images/svgs/calendarDark.svg";
import { ReactComponent as ClockIcon } from "assets/images/svgs/clockdark.svg";
import useUtils from "hooks/useUtils";
type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  sessions?: any[];
};

const WorkshopSessionPopup: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  sessions = [],
}) => {
  const [openDropdownId, setOpenDropdownId] = useState<number | null>(null);
  const { formatDateToMMDDYYYY } = useUtils();

  const toggleDropdown = (id: number) => {
    setOpenDropdownId((prev) => (prev === id ? null : id));
  };
  const modalRef = useOutsideClick(onClose);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-8 rounded-lg shadow-lg w-[90%] sm:w-[380px] h-auto transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        {/* Close Button */}

        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-base text-center text-primaryBlueText font-bold mb-4">
          Workshop Sessions
        </h2>
        {sessions.map((session, idx) => (
          <div key={idx} className="p-3 border rounded-md my-1">
            <p className="flex items-center text-sm gap-2">
              <CalandarIcon /> {formatDateToMMDDYYYY(session.startDateWithMonthAndYear)}
            </p>
            <p className="flex items-center text-sm gap-2">
              <ClockIcon /> {session.startTime} to {session.endTime}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkshopSessionPopup;
